import React, { useContext } from 'react';

import { Button, Picker } from '@gogame/components';
import { FormContext, getIn } from '@gogame/form';
import { useQuery } from '@gogame/query';

import { loadPartners } from 'scenes/CustomAudiences/PartnerAudiences/sources/fields';

export default ({ onClick, depends: dependPaths, disabled }) => {
  const { values } = useContext(FormContext);

  const depends = dependPaths.reduce(
    (result, current) => ({ ...result, [current]: getIn(values, current) }),
    {}
  );
  const dependsValues = Object.values(depends);

  const { data: partnersQ, isLoading: loading } = useQuery(
    ['partners', ...dependsValues],
    () => loadPartners(depends),
    {}
  );

  const handleChange = ([opt]) => onClick(opt.id);

  return (
    <Picker
      button={
        <Button add variant={'outlined'}>
          Audience
        </Button>
      }
      isOptionDisabled={({ isAllow }) => !isAllow}
      onChange={handleChange}
      options={partnersQ}
      disabled={disabled}
      loading={loading}
    />
  );
};
